module.exports = __webpack_public_path__ + "static/media/1 30 skøyter.f0f6c3fd.mp3";